import Id from './Id';
import User from './User';
import CreatorUser from './CreatorUser';
import PaymentDate from './PaymentDate';
import Comment from './Comment';
import Amount from './Amount';
import Created from './Created';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  User: 'Képviselő',
  CreatorUser: 'Létrehozta',
  PaymentDate: 'Befizetés időpontja',
  Amount: 'Összeg',
  Comment: 'Megjegyzés',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'User',
}, {
  value: 'PaymentDate',
}, {
  value: 'Amount',
}, {
  value: 'Comment',
}, {
  value: 'CreatorUser',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'User',
}, {
  value: 'Amount',
}, {
  value: 'PaymentDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'Comment',
}];

export const defaultSort = {
  prop: PaymentDate.propName,
  order: 'descending'
};

export default {
  Id,
  User,
  PaymentDate,
  Amount,
  Comment,
  CreatorUser,
  Created,
  Updated,
};
